"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./FormErrorMessage.css");
function FormErrorMessage({ message }) {
    const MessageContent = (0, react_1.useMemo)(() => {
        return () => {
            if (typeof message === "string") {
                return react_1.default.createElement("div", { id: "form-error-message" }, message);
            }
            else if (message) {
                return react_1.default.createElement(react_1.default.Fragment, null, message);
            }
            else {
                return null;
            }
        };
    }, [message]);
    return (react_1.default.createElement("div", { id: "form-error-message", className: `error ${message ? "visible" : "hidden"}` },
        react_1.default.createElement(MessageContent, null)));
}
exports.default = FormErrorMessage;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRm9ybUVycm9yTWVzc2FnZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy91aS9zaGFyZWQvRm9ybUVycm9yTWVzc2FnZS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLCtDQUF1QztBQUN2QyxrQ0FBZ0M7QUFNaEMsU0FBd0IsZ0JBQWdCLENBQUMsRUFBRSxPQUFPLEVBQTBCO0lBQzFFLE1BQU0sY0FBYyxHQUFHLElBQUEsZUFBTyxFQUFDLEdBQUcsRUFBRTtRQUNsQyxPQUFPLEdBQUcsRUFBRTtZQUNWLElBQUksT0FBTyxPQUFPLEtBQUssUUFBUSxFQUFFO2dCQUMvQixPQUFPLHVDQUFLLEVBQUUsRUFBQyxvQkFBb0IsSUFBRSxPQUFPLENBQU8sQ0FBQzthQUNyRDtpQkFBTSxJQUFJLE9BQU8sRUFBRTtnQkFDbEIsT0FBTyw4REFBRyxPQUFPLENBQUksQ0FBQzthQUN2QjtpQkFBTTtnQkFDTCxPQUFPLElBQUksQ0FBQzthQUNiO1FBQ0gsQ0FBQyxDQUFDO0lBQ0osQ0FBQyxFQUFFLENBQUMsT0FBTyxDQUFDLENBQUMsQ0FBQztJQUVkLE9BQU8sQ0FDTCx1Q0FDRSxFQUFFLEVBQUMsb0JBQW9CLEVBQ3ZCLFNBQVMsRUFBRSxTQUFTLE9BQU8sQ0FBQyxDQUFDLENBQUMsU0FBUyxDQUFDLENBQUMsQ0FBQyxRQUFRLEVBQUU7UUFFcEQsOEJBQUMsY0FBYyxPQUFHLENBQ2QsQ0FDUCxDQUFDO0FBQ0osQ0FBQztBQXJCRCxtQ0FxQkMifQ==